/**
 * Centralized role and permissions configuration.
 * Keep permission checks in one place so new roles can be added easily.
 */

export const JOB_ROLE_ALLOWED_ROLES = ["Administrator", "Location Admin"];

export const canAccessJobRoles = (user) => {
  if (!user || !user.role) return false;
  return JOB_ROLE_ALLOWED_ROLES.includes(user.role);
};
